import React from 'react';
import { Card, CardContent, Typography, Box, Avatar, Skeleton } from '@mui/material';
import { useSpring, animated } from '@react-spring/web';
import { useSelector } from 'react-redux';
import NorthEast from '@mui/icons-material/NorthEast';
import SouthEast from '@mui/icons-material/SouthEast';
import { getCurrencySymbolV2, numberFormatter } from 'utils/currency';
import { StocksReservedIcon, StocksIcon } from 'ui-component/custom-icons/icons';
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded';

const WarehouseWidgetComponent = ({ title, details, isLoading, isPrice = true, type = 1 }) => {
    const selectedCurrency = useSelector((state) => state.main.selectedCurrency);

    const { animatedValue } = useSpring({
        from: { animatedValue: 0 },
        to: { animatedValue: details || 0 },
        delay: 0,
        config: { mass: 1, tension: 120, friction: 14 }, // higher tension, lower friction for faster animation
    });

    const avatarBgColor = type === 1 ? '#fef3d1' : type === 2 ? '#dbedff' : '#E8F5E9';
    const avatarIconColor = type == 1 ? '#e2ac0c' : type == 2 ? '#0069fc' : '#4CAF50';

    return (
        <Card sx={{
            borderRadius: 3,
            boxShadow: '0 4px 12px rgb(0 0 0 / 0.05)',
            height: '80px',
            display: 'flex',
            alignItems: 'center',
            mb: 2,
        }}>
            <CardContent sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                p: 2.5,
                '&:last-child': { pb: 2.5 }
            }}>
                {isLoading ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <Skeleton variant="circular" width={48} height={48} sx={{ mr: 2 }} />
                        <Box sx={{ flexGrow: 1 }}>
                            <Skeleton variant="text" width="70%" height={40} style={{ borderRadius: '12px' }}  />
                        </Box>
                        <Skeleton variant="text" width="30%" height={40} style={{ borderRadius: '12px' }} />
                    </Box>
                ) : (
                    <>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Avatar sx={{ bgcolor: avatarBgColor, width: 48, height: 48, mr: 2, color: avatarIconColor }}>
                                {
                                    title === 'Stocks' ? (
                                        <StocksIcon width={'22px'} height={'22px'} />
                                    ) : title === 'Reserved' ? (
                                        <StocksReservedIcon width={'20px'} height={'20px'} />
                                    ) : (
                                        <AttachMoneyRoundedIcon sx={{ color: avatarIconColor, height: '20px', width: '20px' }} />
                                    )
                                }
                            </Avatar>
                            <Box>
                                <div className={`text-lg fw-500`}>
                                    {title}
                                </div>
                            </Box>
                        </Box>

                        <div className="flex gap-1 justify-between align-items-center">
                            {
                                isPrice ? (
                                    <>
                                        <div style={{ fontSize: '15px' }}>
                                            {getCurrencySymbolV2('usd', 'usd', '20px', '16px')}
                                        </div>
                                        <animated.span style={{ fontSize: '15px', fontWeight: '400' }}>
                                            {animatedValue.to((n) => n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}
                                        </animated.span>
                                    </>
                                ) : (
                                        <animated.span style={{ fontSize: '15px', fontWeight: '400' }}>
                                            {animatedValue.to((n) => n.toLocaleString('en-US', { maximumFractionDigits: 0 }))}
                                        </animated.span>
                                )
                            }

                            {/* <animated.span style={{ fontSize: '15px', fontWeight: '400' }}>
                                {animatedValue.to((n) => n.toLocaleString('en-US', { maximumFractionDigits: 0 }))}
                            </animated.span> */}
                        </div>
                    </>
                )}
            </CardContent>
        </Card>
    );
};

export default WarehouseWidgetComponent;